import { useState, useEffect } from "react";

const UserEditPopup = ({ user, onClose, onSave }) => {
  const [editedUser, setEditedUser] = useState(null);

  // Update state whenever a new user is passed in
  useEffect(() => {
    if (user) {
      setEditedUser({ ...user });
    }
  }, [user]);

  if (!user || !editedUser) return null;

  const handleChange = (e) => {
    setEditedUser((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-[90%] max-w-lg">
        <h2 className="text-xl font-bold mb-4">Edit User</h2>
        <div className="space-y-3">
          <input
            className="w-full border px-3 py-2 rounded"
            name="fullName"
            value={editedUser.fullName}
            onChange={handleChange}
          />
          <input
            className="w-full border px-3 py-2 rounded"
            name="email"
            value={editedUser.email}
            onChange={handleChange}
          />
          <input
            className="w-full border px-3 py-2 rounded"
            name="phone"
            value={editedUser.phone}
            onChange={handleChange}
          />
          {/* Add more fields as needed */}
        </div>
        <div className="mt-4 flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 bg-gray-300 rounded">
            Cancel
          </button>
          <button
            onClick={() => onSave(editedUser)}
            className="px-4 py-2 bg-primary text-white rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserEditPopup;
